var addEvent = function(e, t, n) {
    if (e == null || e == undefined) return;
    if (e.addEventListener) {
        e.addEventListener(t, n, false)
    } else if (e.attachEvent) {
        e.attachEvent("on" + t, n)
    }
};
var removeEvent = function(elem, type, eventHandle) {
    if (elem == null || elem == undefined) return;
    if (elem.removeEventListener) {
        elem.removeEventListener(type, eventHandle, false);
    } else if (elem.attachEvent) {
        elem.detachEvent("on" + type, eventHandle);
    }
};
var waitForFinalEvent = (function() {
    var timers = {};
    return function(callback, ms, uniqueId) {
        if (!uniqueId) {
            uniqueId = "Don't call this twice without a uniqueId";
        }
        if (timers[uniqueId]) {
            clearTimeout(timers[uniqueId]);
        }
        timers[uniqueId] = setTimeout(callback, ms);
    };
})();

const styles = ['font-size: 14px', 'color: #ffffff', 'background-color: #7FA113', 'padding: 4px 0px 4px 8px'].join(';')
    , brandStyles = ['font-size: 14px', 'color: #ffffff', 'background-color: #293133', 'padding: 4px 8px 4px 8px', 'font-weight: bold'].join(';')
    , text = '%cMade by %cW3design https://www.w3design.it/';
console.log(text, styles, brandStyles);

addEvent(window, "load", function() {

});
addEvent(window, "resize", function() {
    /*waitForFinalEvent(function(){
        alert('Resize...');
        //...
    }, 500, "some unique string");*/
});

if($("#contact-form").length>0) {
    $("#contact-form form").validate({
        rules: {
            first_name: {
                required: true
            },
            last_name: {
                required: true
            },
            email: {
                email: true
            },
            privacy: {
                required: true
            },
        },
        messages: {
            first_name: "Campo obbligatorio",
            last_name: "Campo obbligatorio",
            email: "Campo obbligatorio",
            privacy: "Campo obbligatorio",
        }
    });
}

$(window).scroll(function() {
    if ($(this).scrollTop() > 350) {
        $('.scroll-top').fadeIn();
    }else{
        $('.scroll-top').fadeOut();
    }
});


$('.scroll-top').click(function (e) {
    e.preventDefault();
    $("html, body").animate({scrollTop:0}, 'slow');
})

$('.hamburger').click(function() {
    $(this).toggleClass("is-active");
    $('.menu').toggleClass("open");
    $('.header').toggleClass("up");
});

if($("#info-msg").length>0) {
    $('#info-msg').show(function () {
        $(".chiudi").click(function(e){
            e.preventDefault();
            $('#info-msg').hide();
            $('.overlay-popup').hide();
        })
    });
}


if($(".canvas-container").length > 0) {

    gsap.registerPlugin(ScrollTrigger);

    let loadingValue = document.querySelector(".loading-value");
    let canvas = document.querySelector("#canvas");
    let context = canvas.getContext("2d");

    canvas.width = 1920;
    canvas.height = 1080;

    let frameCount = 115;
    let currentFrame = index => (
        `../../img/public/step-stirrer/edited/Sequenza_${(index + 1).toString().padStart(5, '0')}.jpg`
    );

    let images = []
    let stirrer = {
        frame: 0
    };

    let imagesToLoad = frameCount;

    for (let i = 0; i < frameCount; i++) {
        const img = new Image();
        img.onload = onLoad;
        img.src = currentFrame(i);
        images.push(img);
    }

    function onLoad() {
        imagesToLoad--;
        this.onload = null;
        loadingValue.textContent = Math.round((frameCount - imagesToLoad) / frameCount * 100) + "%"

        if (!imagesToLoad) {
            render();
            gsap.set(canvas, { autoAlpha: 1 })
            gsap.to(".loading-container", { autoAlpha: 0 });
        }
    }

    gapScroll = 0;
    if($(window).width() < 1300) {
        gapScroll = 0;
    }

    gsap.to(stirrer, {
        frame: frameCount - 1,
        snap: "frame",
        ease: "none",
        scrollTrigger: {
            trigger: ".canvas-container",
            start:-gapScroll+'%',
            pin: true,
            scrub: 0.5,
            //snap: directionalSnap(1 / (sections.length - 1)),
            end: "+=2500",
            onUpdate: render // use animation onUpdate instead of scrollTrigger's onUpdate
        },
    });

    function render() {
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(images[stirrer.frame], 0, 0);
    }
}

if ($(".rete-vendita-estera").length > 0) {
    var inizializzaContinente = function inizializzaContinente() {
        for (i = 0; i < continent.length; i++) {
            $('#' + continent[i].continent_code + ", #a_" + continent[i].continent_code).data('region', continent[i]).data('id', continent[i].continent_id);
        }

        $('.map-svg g').mouseover(function (e) {
            continent_data = $(this).data('region'); //alert(region_data.region_code);

            $(".regioni a#a_" + continent_data.continent_code).addClass("over");
        }).mouseleave(function () {
            $(".regioni a").removeClass("over");
        });
        $('.regioni a').mouseover(function (e) {
            continent_data = $(this).data('region');
            $(".map-svg g#" + continent_data.continent_code).attr("class", "over");
        }).mouseleave(function () {
            $(".map-svg g").attr("class", "over_");
        });
        $('.map-svg g, .regioni a').on('touchend click', function (e) {
            continent_data = $(this).data('region');
            continent_data_id = $(this).data('id');
            $(".map-svg g, .regioni a").attr("class", "over_").removeAttr("style");
            console.log(continent_data.continent_code);
            $(".map-svg g#" + continent_data.continent_code).css({
                fill: "#F39200"
            }); //console.log(region_data.region_code);
            //CHIAMATA AJAX

            $.ajax({
                type: 'GET',
                url: '/continents/' + continent_data_id + '/retailers-by-country',
                //data: { regione: region_data.region_code },
                dataType: 'json',
                beforeSend: function beforeSend() {
                    $(".loading").show();
                    $(".reg").html("");
                }
            }).done(function (data) {
                var html = "";
                html += '<ol class="breadcrumb">';
                html += '    <li><a href="javascript:void(0)" class="return">' + msg[0].txt_world + '</a></li>';
                html += '    <li class="active">' + data.continente + '</li>';
                html += '</ol>';
                html += '<div class="elenco-info">';
                html += '<div class="wrapper-inner flex">';
                html += '<div class="block x-full">';

                if (data.stati.length > 0) {
                    html += '<ul class="accordion">';
                    $.each(data.stati, function (index, element) {
                        html += '<li>';
                        html += '<a href="javascript:void(0)" class="js-accordion-trigger">' + element.nome + '<i class="fa fa-angle-down"></i></a>';
                        html += '<div class="submenu_accordion" style="display:none">';

                        if (element.rivenditori.length > 0) {
                            $.each(element.rivenditori, function (index, child) {
                                //html += '<h4>' + msg[0][index_type] + '</h4>';
                                html += '<p>';

                                if (child.type['it']) {
                                    //html += child.type['it'] + '<br>';
                                }

                                html += '<strong>' + child.name + '</strong><br>';
                                /*
                                if (child.address) {
                                    html += child.address + '<br>';
                                }

                                html += msg[0].txt_telefono + ' ' + child.telephone;

                                if (child.fax) {
                                    html += ' ' + msg[0].txt_fax + ' ' + child.fax;
                                }

                                html += '<br>';
                                html += msg[0].txt_mail + ': <a href="mailto:' + child.email + '">' + child.email + '</a>';

                                 */
                                html += '</p>';
                            });
                        } else {
                            html += '<p>' + msg[0].no_rivenditori + '</p>';
                        }

                        html += '</div>';
                        html += '</li>';
                    });
                    html += '</ul>';
                } else {
                    html += '<p>' + msg[0].no_rivenditori_world + '</p>';
                }

                html += '</div>';
                html += '</div>';
                html += '</div>';
                html += '</div>';
                $(".reg").html(html);
                $(".loading").hide();
                /*--------------------*/

                /*--------------------*/

                /*--------------------*/

                $('.js-accordion-trigger').bind('click', function (e) {
                    $("#aperto").attr('id', '');
                    $(".fa").removeClass('fa-angle-up').addClass('fa-angle-down');
                    $('.accordion .submenu_accordion').hide();
                    $(this).parent().attr('id', 'aperto');
                    $(this).find('.fa').removeClass('fa-angle-down').addClass('fa-angle-up');
                    $(this).parent().find('.submenu_accordion').show();
                    // scrollare la pagina fino al div .rete-vendita-estera
                    $('html, body').animate({
                        scrollTop: $(".rete-vendita-estera").offset().top
                    }, 500);
                });
                $(".return").click(function () {
                    $(".map-svg g, .regioni a").attr("class", "over_").removeAttr("style");
                    $(".reg").html(inizio_continenti);
                    inizializzaContinente();
                });
            });
        });
    };

    var inizio_continenti = $(".reg").html(); // Sistema i soliti casini di Explorer

    /*if($("#Livello_1").length>0) {
        if($(".map-svg").is(":visible") ) {
            $(".map-svg").css({"height": $(".map-svg").width()*1.266 });
             $(window).resize(function(){
                $(".map-svg").css({"height": $(".map-svg").width()*1.266 });
            })
        }
    }*/

    var continent_data;
    inizializzaContinente();
}

if($('.container-marquee').length>0) {
    let currentScroll = 0;
    let isScrollingDown = true;

    let tween = gsap.to(".marquee__part",{
        xPercent : -100,
        repeat : -1,
        duration : 10,
        ease: "linear",
    }).totalProgress(0.5);

    gsap.set(".marquee__inner",{ xPercent: -50 });

    window.addEventListener("scroll", function (){
        if(window.scrollY > currentScroll){
            isScrollingDown = true
        }else{
            isScrollingDown = false;
        }
        gsap.to(tween,{
            timeScale: isScrollingDown ? 1 : -1,
        });
        currentScroll = window.scrollY;
    })
}
